document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const atcButton = document.querySelector('.product-info__add-button');
  
  if (!stickyBar || !atcButton) return;
  
  // Only run on mobile
  if (window.innerWidth > 767) return;
  
  const HEADER_HEIGHT = 100;
  
  function checkButtonVisibility() {
    const buttonRect = atcButton.getBoundingClientRect();
    const buttonTop = buttonRect.top;
    
    // Show sticky bar when button is within 140px of top (hidden by header)
    if (buttonTop < HEADER_HEIGHT) {
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }
  
  // Check on scroll with throttling for performance
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        checkButtonVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll);
  
  // Initial check
  checkButtonVisibility();
  
  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 767) {
      stickyBar.classList.remove('is-visible');
    } else {
      checkButtonVisibility();
    }
  });
});